import { ChangeDetectorRef, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JobViewService } from "@app/features/customers/customer/jobs-view/service/job-view-service";
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@app/utils/get-api-url';
// import { TemplatesConfigService } from '@app/features/system-settings/general-custom-templates-config/services/templates-config.service';
import { SystemSettingsService } from '@app/services';
var ChangePartStatusModal = /** @class */ (function () {
    function ChangePartStatusModal(formBuilder, ajsScope, 
    // private httpService: TemplatesConfigService,
    bsModalRef, changeDetector, systemSettingsService, jobService) {
        this.formBuilder = formBuilder;
        this.ajsScope = ajsScope;
        this.bsModalRef = bsModalRef;
        this.changeDetector = changeDetector;
        this.systemSettingsService = systemSettingsService;
        this.jobService = jobService;
        this.items = [];
        this.closeBtnName = 'Cancel';
        this.action = '';
        this.formModel = {
            partName: '',
            quantity: null
        };
        this.onClose = new Subject();
    }
    ChangePartStatusModal.prototype.ngOnInit = function () {
        this.items = this.selectedRowsMarkAS.map(function (part) { return ({
            id: part.id,
            name: part.Part,
            qty: parseInt(part.Quantity),
            maxqty: parseInt(part.Quantity)
        }); });
        this.onClose = new Subject();
        this.form = this.formBuilder.group({
            partName: [this.formModel.partName, Validators.required],
            quantity: [this.formModel.quantity, [Validators.required, Validators.min(1)]]
        });
        this.initSelect2Config();
    };
    ChangePartStatusModal.prototype.initSelect2Config = function () {
        this.select2Config = {
            multiple: false,
            width: '100%',
            placeholder: 'Select a part kit',
            allowClear: true,
            ajax: {
                url: environment.apiBasePath + "searchPartKits",
                data: function (searchText, page) {
                    if (!searchText)
                        return false;
                    return { searchText: searchText };
                },
                results: function (data) {
                    return { results: data.partKits || [] };
                }
            }
        };
    };
    ChangePartStatusModal.prototype.ngAfterViewInit = function () {
    };
    ChangePartStatusModal.prototype.increment = function (item) {
        if (item.qty < item.maxqty) {
            item.qty++;
        }
    };
    ChangePartStatusModal.prototype.decrement = function (item) {
        if (item.qty > 0) {
            item.qty--;
        }
    };
    ChangePartStatusModal.prototype.isFormValid = function () {
        // must have at least one item > 0
        var hasValidQty = this.items.some(function (i) { return i.qty > 0; });
        var hasInvalidQty = this.items.some(function (i) { return i.qty > i.maxqty || i.qty < 0 || i.qty === ''; });
        return hasValidQty && !hasInvalidQty;
    };
    ChangePartStatusModal.prototype.close = function () {
        // logic to close modal
    };
    ChangePartStatusModal.prototype.markAsReturn = function () {
        var _this = this;
        var selectedItems = this.items
            .filter(function (item) { return item.qty > 0; })
            .map(function (item) { return ({
            id: item.id,
            allocatedQuantity: item.qty,
            totalQuantity: item.maxqty
        }); });
        // logic to submit returned items
        var formData = new FormData();
        formData.append('partsData', JSON.stringify(selectedItems));
        formData.append('moduleId', String(this.moduleId));
        formData.append('jobtodos', String(this.jobToDos));
        this.jobService.job_part_batch_status_update(this.jobId, this.activeTab, this.status, formData).subscribe({
            next: function (res) {
                _this.onClose.next(res);
            },
            error: function (err) {
                console.error('Error:', err.errorMessage);
                _this.onClose.next(err);
            }
        });
    };
    ChangePartStatusModal.prototype.blockNonNumbers = function (event) {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };
    ChangePartStatusModal.prototype.onQtyInput = function (item, event) {
        var value = event.target.value;
        value = value.replace(/[^0-9]/g, '');
        if (value === '') {
            item.qty = 0;
            event.target.value = 0;
            return;
        }
        var num = Number(value);
        // Restrict max
        if (num > item.maxqty) {
            num = item.maxqty;
        }
        item.qty = num;
        // Force update UI
        event.target.value = num;
    };
    ChangePartStatusModal.prototype.fixQty = function (item) {
        if (item.qty === '' || item.qty === null || isNaN(item.qty)) {
            item.qty = 0;
            return;
        }
        if (item.qty < 0)
            item.qty = 0;
        if (item.qty > item.maxqty)
            item.qty = item.maxqty;
    };
    return ChangePartStatusModal;
}());
export { ChangePartStatusModal };
